export default __webpack_public_path__ + "media/Gmail.7db14.png";